/**
 * Cross-sprint archive/unarchive handlers.
 */

const LOG_PREFIX = '[useCrossSprintActions]';

/**
 * Creates archive and unarchive handlers.
 */
export const createArchiveHandlers = ({
  findSprintForTask,
  actions,
  onUpdateSprint,
}) => ({
  handleCrossSprintArchive: (taskId) => {
    const { sprint: targetSprint, isCurrentSprint } = findSprintForTask(taskId);

    if (!targetSprint) {
      console.warn(`${LOG_PREFIX} handleCrossSprintArchive: Task not found in any sprint:`, taskId);
      return;
    }

    if (isCurrentSprint) {
      actions.handleArchiveTask(taskId);
    } else {
      const updatedSprint = {
        ...targetSprint,
        tasks: targetSprint.tasks.map(t =>
          t.id === taskId
            ? { ...t, archived: true, updatedAt: new Date().toISOString() }
            : t
        ),
      };
      onUpdateSprint?.(updatedSprint);
    }
  },

  handleCrossSprintUnarchive: (taskId) => {
    const { sprint: targetSprint, isCurrentSprint } = findSprintForTask(taskId);

    if (!targetSprint) {
      console.warn(`${LOG_PREFIX} handleCrossSprintUnarchive: Task not found in any sprint:`, taskId);
      return;
    }

    if (isCurrentSprint) {
      actions.handleUnarchiveTask(taskId);
    } else {
      const updatedSprint = {
        ...targetSprint,
        tasks: targetSprint.tasks.map(t =>
          t.id === taskId
            ? { ...t, archived: false, updatedAt: new Date().toISOString() }
            : t
        ),
      };
      onUpdateSprint?.(updatedSprint);
    }
  },

  handleCrossSprintDelete: (taskId) => {
    const { sprint: targetSprint, isCurrentSprint } = findSprintForTask(taskId);

    if (!targetSprint) {
      console.warn(`${LOG_PREFIX} handleCrossSprintDelete: Task not found in any sprint:`, taskId);
      return;
    }

    if (isCurrentSprint) {
      actions.handleDeleteTask(taskId);
    } else {
      const updatedSprint = {
        ...targetSprint,
        tasks: targetSprint.tasks.filter(t => t.id !== taskId),
      };
      onUpdateSprint?.(updatedSprint);
    }
  },
});
